import {appName} from '../settings/constants'
import {createSelector} from 'reselect'
import {Record} from 'immutable'
import RestService from '../helpers/RestService'
import {arrayToMap, arrayPrimitivesToMap, formatErrorMessage} from '../helpers/common'
import {currentSubjectSelector, subjectsCursorSelector, subjectsMapSelector} from './subjects'
import {
    QUESTIONS_SUCCESS,
    QUESTION_CHANGE_CATEGORY,
    QUESTION_CHANGE_QUESTION_CATEGORY,
    TRASHED_QUESTIONS_RECOVER,
    QUESTIONS_START,
    QUESTIONS_FAIL,
    putToTrash,
    questionsByCategorySelector,
    QUESTION_DELETE,
    QUESTIONS_MASS_DELETE,
} from './questions'
import {restructureCategories, adjustEntitiesFieldsType, addCatSubcatPrefix, removePrefixCatSubcatId, setPrefixToCatSubcatId, DISABLED, ENABLED, _getId, _getIds, _trashedScopeCB, _isTrashed, _getEntity, _getEntityWithTrashed, _entities, _entitiesWithTrashed, _entitiesGroup, normalizeCategories} from './_utils'
import { SubmissionError } from 'redux-form'
import {ajaxUrls} from '../settings/routes'


/**
 * Constants
 * */

export const moduleName = 'categories'
const prefix = `${appName}/${moduleName}`

export const CATEGORIES_START = `${prefix}/CATEGORIES_START`
export const CATEGORIES_SUCCESS = `${prefix}/CATEGORIES_SUCCESS`
export const CATEGORIES_FAIL = `${prefix}/CATEGORIES_FAIL`
export const MASS_CATEGORIES_SUCCESS = `${prefix}/MASS_CATEGORIES_SUCCESS`


export const SET_CATEGORY_CHECKED_STATE = `${prefix}/SET_CATEGORY_CHECKED_STATE`
export const UNCHECK_ALL = `${prefix}/UNCHECK_ALL`
export const SET_CATEGORIES_CURSOR = `${prefix}/SET_CATEGORIES_CURSOR`

export const CATEGORIES_ENTITIES_CHANGE = `${prefix}/CATEGORIES_ENTITIES_CHANGE`
export const CATEGORIES_ENTITIES_DELETE = `${prefix}/CATEGORIES_ENTITIES_DELETE`

/**
 * Reducer
 * */

const categoryRecord = Record({
    id : null,
    name : "",
    parent_id : null,
    created_at : null,
    updated_at : null,
    questionsIds : arrayPrimitivesToMap([]),
    questionsLoading : false,
    questionsLoaded : false,

    status : ENABLED,

    subject_id : null,
})

const ReducerRecord = Record({
    entities : arrayToMap([], categoryRecord),
    cursor : null,
    checked : arrayPrimitivesToMap([]),
})

const defaultState = new ReducerRecord()

export const reducer = (state = defaultState, action) => {
    const {type, payload} = action

    switch (type) {
        case CATEGORIES_SUCCESS : {
            let {categories} = payload
            return state.update('entities', currEntities => currEntities.merge(arrayToMap(categories, categoryRecord)))
            break
        }
        case MASS_CATEGORIES_SUCCESS : {
            let {categoriesData} = payload
            categoriesData.forEach(cdItem => {
                let {categories} = cdItem
                state = state.update('entities', currEntities => currEntities.merge(arrayToMap(categories, categoryRecord)))
            })
            return state
            break
        }
        case QUESTIONS_START : {
            let {requestedCategories = []} = payload
            requestedCategories.forEach(id => {
                state = state.setIn(['entities', id, 'questionsLoading'], true)
            })
            return state
            break
        }
        case QUESTIONS_SUCCESS : {
            let {questions = [], requestedCategories = []} = payload
            questions.forEach(question => {
                const {id : questionId, category_id, subcategory_id} = question
                const ct = subcategory_id ? subcategory_id : category_id
                state = state.updateIn(['entities', ct, 'questionsIds'], questionsIds => questionsIds.set(questionId, 1))
            })
            requestedCategories.forEach(id => {
                state = state.setIn(['entities', id, 'questionsLoading'], false)
                                .setIn(['entities', id, 'questionsLoaded'], true)
            })
            return state
            break
        }
        case QUESTIONS_FAIL : {
            let {requestedCategories = []} = payload
            requestedCategories.forEach(id => {
                state = state.setIn(['entities', id, 'questionsLoading'], false)
                                .setIn(['entities', id, 'questionsLoaded'], false)
            })
            return state
            break
        }
        case QUESTION_CHANGE_CATEGORY : {
            let {prevCategoryId, categoryId, question : {id : questionId}} = payload
            return state.updateIn(['entities', prevCategoryId], prevCategory => prevCategory.deleteIn(['questionsIds', questionId]))
                .updateIn(['entities', categoryId], category => category.setIn(['questionsIds', questionId], 1))
            break
        }
        case SET_CATEGORY_CHECKED_STATE : {
            const {checkData = []} = payload
            checkData.forEach(chd => {
                const {id, isChecked} = chd
                if (isChecked) {
                    state = state.setIn(["checked", id], 1)
                } else {
                    state = state.deleteIn(["checked", id])
                }
            })
            return state
            break
        }
        case UNCHECK_ALL : {
            return state.set("checked", arrayPrimitivesToMap([]))
            break
        }
        case SET_CATEGORIES_CURSOR : {
            const {id} = payload
            return state.set("cursor", id)
            break
        }
        case CATEGORIES_ENTITIES_CHANGE : {
            const {categories = []} = payload
            categories.forEach(category => {
                const {id} = category
                state = state.setIn(["entities", id], new categoryRecord({...category}))
            })
            return state
            break
        }
        case CATEGORIES_ENTITIES_DELETE : {
            const {ids = []} = payload
            ids.forEach(id => {
                state = state.updateIn(["entities", id], category => category.set('status', DISABLED))
                state = state.deleteIn(["checked", id])
                if (state.get("cursor") === id) {
                    state = state.set("cursor", null)
                }
            })
            return state
            break
        }
        case QUESTION_CHANGE_QUESTION_CATEGORY : {
            const {questionId, category_id, prev_category_id} = payload
            return state.deleteIn(['entities', prev_category_id, 'questionsIds', questionId])
                        .setIn(['entities', category_id, 'questionsIds', questionId], 1)
            break
        }
        case TRASHED_QUESTIONS_RECOVER : {
            const {categoryId, subcategoryId} = payload
            if (typeof subcategoryId !== 'undefined') {
                state = state.updateIn(['entities', subcategoryId], category => category.set('status', ENABLED))
            }
            return state.updateIn(['entities', categoryId], category => category.set('status', ENABLED))
            break
        }
        case QUESTION_DELETE : {
            const {categoryId, questionId} = payload
            if (typeof categoryId !== 'undefined') state = state.deleteIn(['entities', categoryId, 'questionsIds', questionId])
            return state
            break
        }
        case QUESTIONS_MASS_DELETE : {
            const {questionsData = []} = payload
            questionsData.forEach(function({questionId, categoryId}) {
                if (typeof categoryId !== 'undefined') state = state.deleteIn(['entities', categoryId, 'questionsIds', questionId])
            })
            return state
            break
        }
        default : {
            return state
            break
        }
    }
}


/**
 * Selectors
 * */

const stateSelector = state => state[moduleName]
export const categoriesMapSelector = createSelector(stateSelector, state => state.entities)
export const categoriesSelector = createSelector(categoriesMapSelector, _entities)
export const categoriesWithTrashedSelector = createSelector(categoriesMapSelector, _entitiesWithTrashed)

export const categoriesGroupSelector = createSelector(categoriesMapSelector, _getIds, _entitiesGroup)

export const categoriesCursorSelector = createSelector(stateSelector, state => state.cursor)
export const checkedCategoriesIdsMapSelector = createSelector(stateSelector, state => state.checked)
export const checkedCategoriesIdsSelector = createSelector(checkedCategoriesIdsMapSelector, ids => ids.keySeq().toArray())
export const currentCursorCategorySelector = createSelector(categoriesMapSelector, categoriesCursorSelector, _getEntity)

export const checkedCategoriesSelector = createSelector(categoriesMapSelector, checkedCategoriesIdsSelector, (categoriesMap, checkedCategoriesIds) => checkedCategoriesIds.map(id => categoriesMap.get(id)).filter(category => category).filter(_trashedScopeCB))

export const anyQuestionIsLoadingSelector = createSelector(checkedCategoriesSelector, checkedCategories => checkedCategories.some(category => category.questionsLoading))

const __currentSubjectSelector = state => { // can't just import currentSubjectSelector because of the compiling bug
    const cursor = state.subjects.cursor
    const subjectsMap = state.subjects.entities
    return subjectsMap.get(cursor)
}
export const parentCategoriesSelector = createSelector(__currentSubjectSelector, categoriesMapSelector, (currentSubject = {}, categoriesMap) => {
    const {categoriesIds} = currentSubject
    return (categoriesIds ? categoriesIds.keySeq().toArray() : []).map(id => categoriesMap.get(id)).filter(category => category && !category.parent_id).filter(_trashedScopeCB)
})
export const subcategoriesSelector = createSelector(__currentSubjectSelector, categoriesMapSelector, (currentSubject = {}, categoriesMap) => {
    const {categoriesIds} = currentSubject
    return (categoriesIds ? categoriesIds.keySeq().toArray() : []).map(id => categoriesMap.get(id)).filter(category => category && !!category.parent_id).filter(_trashedScopeCB)
})

export const categorySelector = createSelector(categoriesMapSelector, _getId, _getEntity)
export const categoryWithTrashedSelector = createSelector(categoriesMapSelector, _getId, _getEntityWithTrashed)
export const createCategorySelector = () => categorySelector
export const createCategoryWithTrashedSelector = () => categoryWithTrashedSelector


export const categoriesTreeMapSelector = createSelector(categoriesMapSelector, _getIds, (allCategoriesMap, ids) => {
    return _getCategoriesTreeById(allCategoriesMap, ids)
})
export const allCategoriesTreeMapSelector = createSelector(categoriesMapSelector, allCategoriesMap => {
    return _getCategoriesTreeById(allCategoriesMap, allCategoriesMap.valueSeq().toArray().map(({id}) => id))
})

const _getCategoriesTreeById = (allCategoriesMap, ids) => {
    let categoriesMap = {}
    let subcategories = []
    ids.forEach(id => {
        const _item = allCategoriesMap.get(id)
        if (!_item) return
        if (!_trashedScopeCB(_item)) return

        let item = _item.toJS()

        if (item.parent_id) {
            subcategories = [
                ...subcategories,
                item,
            ]
        } else {
            categoriesMap = {
                ...categoriesMap,
                [item.id] : {
                    ...item,
                    subcategories : [],
                },
            }
        }
    })
    subcategories.forEach(subcategory => {
        const {parent_id} = subcategory
        let parent = categoriesMap[parent_id]
        if (parent) {
            parent = {
                ...parent,
                subcategories : [
                    ...parent.subcategories,
                    subcategory
                ]
            }
            categoriesMap[parent_id] = parent
        } else {
            let parent = allCategoriesMap.get(parent_id).toJS()
            parent = {
                ...parent,
                subcategories : [
                    subcategory,
                ]
            }
            categoriesMap[parent_id] = parent
        }
    })
    return categoriesMap
}

/**
 * Action Creators
 * */

export const uncheckCategories = () => ({type : UNCHECK_ALL})

export const setCategoriesCursor = (id) => ({
    type : SET_CATEGORIES_CURSOR,
    payload : {
        id
    }
})

export const changeCategoriesEntities = (params) => {
    const {categories, subjectId} = params
    return {
        type : CATEGORIES_ENTITIES_CHANGE,
        payload : {
            categories,
            subjectId
        }
    }
}

export const categoriesSuccess = params => {
    const {categories, subjectId} = params
    return {
        type : CATEGORIES_SUCCESS,
        payload : {
            categories : normalizeCategories({categories, subjectId}),
            subjectId,
        }
    }
}

export const massCategoriesSuccess = params => {
    let {categoriesDataObj} = params
    let categoriesData = []

    Object.values(categoriesDataObj).forEach(cdoItem => {
        let {subjectId, categories} = cdoItem
        categories = normalizeCategories({categories, subjectId})
        categoriesData = [
            ...categoriesData,
            {
                subjectId,
                categories,
            }
        ]
    })

    return {
        type : MASS_CATEGORIES_SUCCESS,
        payload : {
            categoriesData
        }
    }
}



/**
 * Thunk
 * */
export const checkAndUploadCategories = (subjectId) => {
    return (dispatch, getState) => {
        const state = getState()
        const currentSubject = currentSubjectSelector(state, subjectId)
        if (!currentSubject) return
        const {categoriesLoaded, categoriesLoading} = currentSubject
        if (categoriesLoading || categoriesLoaded) return

        dispatch({
            type : CATEGORIES_START,
            payload : {
                subjectId
            }
        })
        RestService.postFormData(ajaxUrls.categoriesTotal, `Branch=${JSON.stringify({branch_id: subjectId})}`)
            .then(res => {
                if (res.status >= 400) throw new Error(res.statusText)
                return res.json()
            })
            .then(response => {
                const {errcode, categories} = response
                if (errcode !== 200) throw new Error("Failed to fetch categories") // TODO discuss possible messages from server
                dispatch(categoriesSuccess({categories, subjectId}))
            })
            .catch(error => {
                dispatch({
                    type : CATEGORIES_FAIL,
                    payload : {
                        subjectId
                    }
                })
                console.warn(error) // TODO discuss with backend error handling
            })
    }
}

export const setCategoryCheckedState = (params) => {
    const {id, isChecked} = params
    return (dispatch, getState) => {
        const state = getState()

        const allCategoriesTreeMap = allCategoriesTreeMapSelector(state)
        const category = categorySelector(state, id)

        if (allCategoriesTreeMap[id]) { // category
            let checkData = [
                {id, isChecked}
            ]
            allCategoriesTreeMap[id].subcategories.forEach(subcat => {
                checkData = [
                    ...checkData,
                    {id:subcat.id, isChecked}
                ]
            })
            dispatch({
                type : SET_CATEGORY_CHECKED_STATE,
                payload : {
                    checkData,
                }
            })
        } else { // subcategory
            dispatch({
                type : SET_CATEGORY_CHECKED_STATE,
                payload : {
                    checkData : [{id:category.parent_id, isChecked : true}, {id, isChecked}],
                }
            })
        }
    }
}

export const deleteCategoriesEntities = (params) => {
    const {ids, subjectId} = params
    return (dispatch, getState) => {
        const state = getState()
        const categoriesMap = categoriesMapSelector(state)
        const categories = categoriesSelector(state)
        let accumulate = [...ids]
        ids.forEach(id => {
            const category = categoriesMap.get(id)
            if (category && !category.parent_id) {
                const subcatIds = categories.filter(cat => cat.parent_id === id).map(subcat=>subcat.id)
                accumulate = [
                    ...accumulate,
                    ...subcatIds,
                ]
            }
        })

        let questionsForTrash = questionsByCategorySelector(state, accumulate)
        dispatch({
            type : CATEGORIES_ENTITIES_DELETE,
            payload : {
                ids : accumulate,
                subjectId,
            }
        })
        dispatch(putToTrash({
            subjectId,
            trashedQuestions : questionsForTrash.map(({id}) => ({id}))
        }))
    }
}

export const handleAfterCreationCheckedState = (params) => {
    const {id} = params
    return (dispatch, getState) => {
        const state = getState()
        const {parent_id} = categorySelector(state, id)
        if (!parent_id) return
        const checkedIds = checkedCategoriesIdsSelector(state)
        if (checkedIds.includes(parent_id)) dispatch(setCategoryCheckedState({id, isChecked : true}))
    }
}


/*
* Redux Form
* */

export const handleCreateCategory = (params) => {
    const {name, subjectId : branch_id, parent = {}, isSubcategory} = params
    const {id : category_id} = parent
    let request
    if (!isSubcategory) {
        let data = new FormData()
        data.append('Category', JSON.stringify({name, branch_id}))
        request = RestService.bodyAsFormData(ajaxUrls.categoriesCreate, data)
    } else {
        let data = new FormData()
        data.append('Subcategory', JSON.stringify({name, category_id : removePrefixCatSubcatId(category_id)}))
        request = RestService.bodyAsFormData(ajaxUrls.subcategoriesCreate, data)
    }
    return request
        .then(res => {
            if (res.status >= 400) {
                throw new SubmissionError({
                    _error : res.statusText,
                })
            }
            return res.json()
        })
        .then(response => {
            let {errcode, category, subcategory, message} = response
            if (errcode === 200) {
                if (!isSubcategory) {
                    const {id, name, created_at, updated_at} = category
                    return {id : setPrefixToCatSubcatId(id, isSubcategory), name, parent_id : null, created_at : +created_at, updated_at : +updated_at, subject_id : branch_id,}
                } else {
                    const {id, name, category_id, created_at, updated_at} = subcategory
                    return {id : setPrefixToCatSubcatId(id, isSubcategory), name, parent_id : setPrefixToCatSubcatId(category_id, false), created_at : +created_at, updated_at : +updated_at, subject_id : branch_id,}
                }
            } else {
                throw new SubmissionError({
                    _error : formatErrorMessage(message),
                })
            }
        })
}

export const handleUpdateCategory = (params) => {
    const {id, name, isSubcategory} = params
    let data = new FormData()

    data.append(`${isSubcategory ? "Subcategory" : "Category"}`, JSON.stringify({id : removePrefixCatSubcatId(id), name}))

    let url = isSubcategory ? ajaxUrls.subcategoriesUpdate : ajaxUrls.categoriesUpdate

    return RestService.bodyAsFormData(url, data)
        .then(res => {
            if (res.status >= 400) {
                throw new SubmissionError({
                    _error : res.statusText,
                })
            }
            return res.json()
        })
        .then(res => {
            let {errcode, category, subcategory, message} = res
            if (errcode === 200) {
                if (!isSubcategory) {
                    const {id, name, created_at, updated_at} = category
                    return {id : setPrefixToCatSubcatId(id, isSubcategory), name, parent_id : null, created_at : +created_at, updated_at : +updated_at}
                } else {
                    const {id, name, category_id, created_at, updated_at} = subcategory
                    return {id : setPrefixToCatSubcatId(id, isSubcategory), name, parent_id : setPrefixToCatSubcatId(category_id, false), created_at : +created_at, updated_at : +updated_at}
                }
            } else {
                throw new SubmissionError({
                    _error : formatErrorMessage(message),
                })
            }
        })
}

export const handleDeleteCategory = (params) => {
    const {id, isSubcategory} = params
    let url = isSubcategory ? ajaxUrls.subcategoriesDelete : ajaxUrls.categoriesDelete
    return RestService.postFormData(url, `${isSubcategory ? "Subcategory" : "Category"}=` + JSON.stringify({id : removePrefixCatSubcatId(id),}))
        .then(res => {
            if (res.status >= 400) {
                throw new SubmissionError({
                    _error : res.statusText,
                })
            }
            return res.json()
        })
        .then(res => {
            let {errcode, id : deletedId, message} = res
            if (errcode === 200) {
                return setPrefixToCatSubcatId(deletedId, isSubcategory)
            } else {
                throw new SubmissionError({
                    _error : formatErrorMessage(message),
                })
            }
        })
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/modules/categories.js